import { patchtLead, postLead } from '@/api/services'

const actions = {
  async patchLeadAction ({ rootState, dispatch }, leadData) {
    try {
      if (!rootState.product.lead || !rootState.product.lead.uuid) return

      clearInterval(window.leadInterval)

      await patchtLead({
        cookieGA: rootState.product.cookieGA || rootState.urlParams._ga || null,
        data: {
          ...leadData,
          step: /bolsa-protegida/.test(rootState.product.alias)
            ? `${window.location.pathname}${window.location.hash.replace('#/', '')}`
            : rootState.steps.currentStep,
          type: rootState.product.lead.type || rootState.product.aliasEN.toUpperCase().replace('-', '_')
        },
        leadUuid: rootState.product.lead.uuid
      })
    } catch (error) {
      this._vm.$sentry.logWithContext({
        level: 'error',
        tags: {
          app_product: rootState.product.alias,
          app_step: rootState.steps.currentStep,
          app_errorZone: 'patchLeadAction'
        },
        ctx: {
          label: '[LEAD] - patchLeadAction'
        },
        error
      })
    }

    window.leadInterval = setInterval(() => {
      dispatch('patchLeadAction')
    }, 300000)
  },

  async postLeadAction ({ rootState, commit }, { cookieGA, data }) {
    await postLead({ cookieGA, data })
      .then((response) => {
        commit('product/setLeadUuid', response.data.uuid, { root: true })
      })
      .catch((error) => {
        this._vm.$sentry.logWithContext({
          level: 'error',
          tags: {
            app_product: rootState.product.alias,
            app_step: rootState.steps.currentStep,
            app_errorZone: 'postLeadAction'
          },
          ctx: {
            label: '[LEAD] - postLeadAction'
          },
          error
        })
      })
  }
}

export default {
  namespaced: true,
  actions
}
